import React from "react";

export default function StatsRowBlock({ id, type, items = [] }) {
  if (!items.length) return null;

  return (
    <div className="container">
      <div className="col-12 col-md-8 col-lg-6 mx-auto text-center py-4 border-bottom mb-5">
        <div className="my-5 d-none d-md-flex align-items-start justify-content-between">
          {items.map((stat) => (
            <div key={`${stat.value}-${stat.label}`}>
              <span className="display-3 fw-bold text-primary d-block">{stat.value}</span>
              <span className="d-block fs-9 fw-bolder tracking-wide text-uppercase text-muted">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
